import VisibilityIcon from "@material-ui/icons/Visibility";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

import Tooltip from "react-bootstrap/Tooltip";
import { Scrollbars } from "react-custom-scrollbars";
import { useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import constant from "../../../../util/constant";
import { formatNumberAsPerLocale, getEligibleSubscriptionPlans } from "../../../../util/helpers";
import { games } from "../../../../util/icons";
import tournamentConstant from "../../../../util/tournamentConstant";
import { ScrollPage } from "../../../shared/customScrollBar";
import OptInDetails from "../../offers/optInDetails";

const { ROUTES, BRANDING: { APP_SHORT_NAME } } = constant;
const { TABS } = tournamentConstant;

const TournamentsList = ( {
  gamerId,
  tournamentsList,
  values,
  location,
  handleShowAll,
} ) => {
  const ref = useRef( null );
  const history = useHistory();
  const { configuration } = useSelector( state => ( {
    configuration: state.partner.partnerDetail?.configuration || {},
  } ) );

  const handleViewPage = ( offerId ) => {
    history.push( {
      pathname: ( `${ ( ROUTES.PARTNER_GAMER_TOURNAMENT_DETAILS )
        .replace( ":gamerId", gamerId )
        .replace( ":offerId", offerId )
      }?tab=${ TABS.TOURNAMENT_DETAIL }` ),
      state: [ ...location.state,
        ...[ { from: "gamerLinkedTournaments", path: location.pathname, state: location.search } ],
      ],
    } );
  };

  return (
    <>
      <Scrollbars renderThumbVertical={ScrollPage} className={`track-horizontal ${ values.viewType === 0 ? "track-horizontal-list" : "" }`}>
        <div className={`games-grid-wrapper ${ values.viewType === 0 ? "games-list-wrapper" : "" } no-scrollbar`}
        >
          {Boolean( tournamentsList.length ) && tournamentsList.map( ( tournament, index ) => (
            <div className="col-games-grid-box width-50" key={index}>
              <div className="offer-detail-box" ref={ref}>
                <div className="offer-detail-box-top grid-only">
                  <div className="image-box">
                    <img src={games} alt="games" />
                  </div>
                  <div className="offer-detail-box-top-body flex-column">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="ribbon-container">
                        <span className={`ribbon badge ${ tournament?.statusTitle?.class }`}>{tournament?.statusTitle?.title}</span>
                      </div>
                      <strong className='text-truncate'>{tournament.tournamentName}</strong>
                      <div className='icon cursor-pointer'>
                        <VisibilityIcon onClick={() => handleViewPage( tournament.tournamentId )}/>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div className="left-side">
                        <p>{tournament.startDate} - {tournament.endDate}</p>
                        <p className="mb-0"><strong className='inline-block mb-0'>Place:</strong> <strong className='mb-0 inline-block opt-text'>{tournament.myPlace}</strong></p>
                      </div>
                      <div className='opt-in-text align-items-start'>
                              Opt In:
                        <OptInDetails
                          optInDetail={tournament.optInDetail}
                          eligibleSubPlans={getEligibleSubscriptionPlans( tournament.optInDetail.membershipId, configuration.membershipTypes )}
                        />
                      </div>
                      <div className="right-side">
                        <img src={ tournament.partnerLogo} alt="Partner Icon" className="partner-image position-static" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between grid-only mt-4 mb-3">
                  <div className="games-tags-list-wrapper my-0 grid-only">
                    <strong>Game: </strong>
                    <div className="games-tags-list">
                      <div className="games-tags">
                        <div className="image-box">
                          <img src={tournament.gameIcon} alt="User Icon" />
                        </div>
                        <span>{tournament.gameName}</span>
                      </div>
                    </div>
                  </div>
                  <div className="list-content" >
                    {/* Show only rewards for first 2 places in the card view */}
                    {[ ...tournament.rewards ].splice( 0, 2 ).map( ( reward, i ) => (
                      <div className="text-block" key={i}>
                        <span>{reward.place}</span>
                        <span>{formatNumberAsPerLocale( reward.reward_value )}</span>
                        <span>{ APP_SHORT_NAME } Points</span>
                      </div>
                    ) )}
                    {tournament.rewards.length > 2 && (
                      <div className="text-block text-right">
                        <Link
                          className="link"
                          title="Show All"
                          onClick={() => handleShowAll( tournament.rewards )}
                        >
                        Show All
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
                <div className="games-desc-text grid-only">
                  <strong>Description:</strong>
                  <OverlayTrigger
                    container={ref}
                    placement='auto'
                    overlay={<Tooltip><p>{tournament.tournamentDescription}</p></Tooltip>}>
                    <p className="text-truncate">{tournament.tournamentDescription}</p>
                  </OverlayTrigger>
                </div>
                <div className="gamer-offer-table-body list-only">
                  <div className="td"><strong className='line-ellipses'>{tournament.tournamentName}</strong></div>
                  <OverlayTrigger
                    container={ref}
                    placement='auto'
                    overlay={<Tooltip><p>{tournament.tournamentDescription}</p></Tooltip>}
                  >
                    <div className="td"><p className="line-ellipses">{tournament.tournamentDescription}</p></div>
                  </OverlayTrigger>
                  <div className="td">{tournament.gameName}</div>
                  <div className="td">{tournament.startDate}</div>
                  <div className="td">{tournament.endDate}</div>
                  <div className="td">
                    <span className="opt-in-text">
                      <OptInDetails
                        optInDetail={tournament.optInDetail}
                        eligibleSubPlans={getEligibleSubscriptionPlans( tournament.optInDetail.membershipId, configuration.membershipTypes )}
                      />
                    </span>
                  </div>
                  <div className='td'>
                    <span className={`badge ${ tournament?.statusTitle?.class }`}>{tournament?.statusTitle?.title}</span>
                  </div>
                  <div className="td">{tournament.myPlace}</div>
                  <div className="td">
                    <div className='icon cursor-pointer'>
                      <VisibilityIcon onClick={() => handleViewPage( tournament.tournamentId )}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) )}
          {!tournamentsList.length && (
            <div className='no-record' data-testId='no-record-found'>
                  No Tournament Found
            </div>
          )}
        </div></Scrollbars>
    </>
  );
};

TournamentsList.propTypes = {
  gamerId: PropTypes.string,
  values: PropTypes.object,
  tournamentsList: PropTypes.array,
  location: PropTypes.object,
  handleShowAll: PropTypes.func,
};

export default TournamentsList;
